var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showConfetti)?_c('div',{staticClass:"confetti-container"},_vm._l((120),function(n){return _c('span',{key:n,style:(_vm.confettiStyle())})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }